/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaOverlayFooter/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaOverlayFooter({
  children,
  viewPath = "/DesignSystem/TysiaOverlay/TysiaOverlayFooter",
  height = "62px",
  backgroundColor,
  borderTopWidth = 1,
  borderTopStyle = "solid",
  borderTopColor,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  width = "100%",
  alignItems = "center",
  justifyContent = "space-between"
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let backgroundColorOrdtColorsWhite = backgroundColor ?? dtColorsWhite
let borderTopColorOrdtColorsNeutral200 = borderTopColor ?? dtColorsNeutral200
let paddingLeftOrdtSpaceM = paddingLeft ?? dtSpaceM
let paddingRightOrdtSpaceM = paddingRight ?? dtSpaceM
let paddingTopOrdtSpaceS = paddingTop ?? dtSpaceS
let paddingBottomOrdtSpaceS = paddingBottom ?? dtSpaceS
  return (<React.Fragment
>
<div
  data-testid="TysiaOverlayFooter.Horizontal"
  data-view-path={viewPath}
 style={{'--h-1-2pvlce': typeof height === 'number' ? `${height}px` : height,'--bc-2-2pvlce': backgroundColorOrdtColorsWhite,'--btw-3-2pvlce': typeof borderTopWidth === 'number' ? `${borderTopWidth}px` : borderTopWidth,'--bts-4-2pvlce': borderTopStyle,'--btc-5-2pvlce': borderTopColorOrdtColorsNeutral200,'--pl-6-2pvlce': typeof paddingLeftOrdtSpaceM === 'number' ? `${paddingLeftOrdtSpaceM}px` : paddingLeftOrdtSpaceM,'--pr-7-2pvlce': typeof paddingRightOrdtSpaceM === 'number' ? `${paddingRightOrdtSpaceM}px` : paddingRightOrdtSpaceM,'--pt-8-2pvlce': typeof paddingTopOrdtSpaceS === 'number' ? `${paddingTopOrdtSpaceS}px` : paddingTopOrdtSpaceS,'--pb-9-2pvlce': typeof paddingBottomOrdtSpaceS === 'number' ? `${paddingBottomOrdtSpaceS}px` : paddingBottomOrdtSpaceS,'--w-10-2pvlce': typeof width === 'number' ? `${width}px` : width,'--ai-11-2pvlce': alignItems,'--jc-12-2pvlce': justifyContent}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}